import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { List } from 'immutable';
import {jsxActions as archivedKitTypesViewActions} from '../../../actions/Administration/MatSettingsPage/archivedKitTypesViewActions.js'
import { jsxActions as headerSettingsActions} from '../../../actions/Header/headerSettingsActions.js';
import { jsxActions as fetchEntitiesActions } from '../../../actions/FetchEntities/fetchEntitiesActions.js';
import { jsxActions as archivedKitTypesViewGridActions} from '../../../actions/Administration/MatSettingsPage/archivedKitTypesViewGridActions';
import { jsxActions as createKitTypeFormActions} from '../../../actions/Administration/MatSettingsPage/createKitTypeFormActions.js';
import { jsxActions as matSettingsPageActions} from '../../../actions/Administration/MatSettingsPage/matSettingsPageActions';
import { gridsNames} from '../../../enums/gridsNames';
import ArchivedKitTypesView from '../../../components/Administration/MatSettingsPage/KitTypesPage/ArchivedKitTypesView/archivedKitTypesView';

function mapDispatchToProps(dispatch) {
  return {

    actions: {
      ...bindActionCreators(archivedKitTypesViewActions, dispatch),
      header: bindActionCreators(headerSettingsActions, dispatch),
      fetchEntitiesActions:    bindActionCreators(fetchEntitiesActions, dispatch),
      archivedKitTypesViewGridActions: bindActionCreators(archivedKitTypesViewGridActions, dispatch),
      createKitTypeFormActions : bindActionCreators(createKitTypeFormActions, dispatch),
      matSettingsPageActions : bindActionCreators(matSettingsPageActions, dispatch)
    }

  }
}

let ArchivedKitTypesViewContainer = connect(
  (state) => {
    let grid = state.grid.get(gridsNames.ADMINISTRATION_MAT_SETTINGS_ARCHIVED_KIT_TYPES) ? state.grid.get(gridsNames.ADMINISTRATION_MAT_SETTINGS_ARCHIVED_KIT_TYPES) : null;
    return {
      sGrid:  grid,
      sHasRows: grid && grid.get('rows') ? grid.get('rows').size > 0 : false,
      sSelectedRowsData: grid ? grid.get('selectedRowsData') : List(),
      sCreateKitTypeFormData: state.administration.getIn(['matSettingsPage', 'createKitTypeForm']),
      sLoggedInUser : state.login.get('loggedInUser'),
    };
  },
  mapDispatchToProps
)(ArchivedKitTypesView);


export default ArchivedKitTypesViewContainer;



